/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FieldComment } from '@pwc/pwc-deals-ui';
import { CommentTarget } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import {
  getFakeClientUser,
  getIsThirdPartyMember,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import useAutoLock from 'common/hooks/useAutoLock';
import { useIsPreviousVersionSelected } from 'common/hooks/useIsPreviousVersionSelected';
import { useIsAddingCommentEnabled } from '../hooks/useIsAddingCommentEnabled';

interface Props {
  fieldKey: CommentTarget;
  className?: string;
  cssStyles?: string;
}

const FieldCommentWrapper: React.FC<Props> = ({
  fieldKey,
  className,
  cssStyles,
  children,
}) => {
  const { isLocked } = useAutoLock();
  const isFakeClientUser = useSelector(getFakeClientUser);
  const isThirdPartyMember = useSelector(getIsThirdPartyMember);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const isAddingCommentEnabled = useIsAddingCommentEnabled();
  const isPreviousVersionSelected = useIsPreviousVersionSelected();

  return (
    <FieldComment
      fieldKey={fieldKey}
      isCommentingEnabled={
        isAddingCommentEnabled && !isFakeClientUser && !isThirdPartyMember
      }
      isContentLocked={isLocked}
      className={className}
      cssStyles={cssStyles}
      showAddComment={!isPreviousVersionSelected}
    >
      {children}
    </FieldComment>
  );
};

export default FieldCommentWrapper;
